import { render } from "./TvmFeedBack.vue?vue&type=template&id=4c8b6824&scoped=true"
import script from "./TvmFeedBack.vue?vue&type=script&lang=js"
export * from "./TvmFeedBack.vue?vue&type=script&lang=js"

import "./TvmFeedBack.vue?vue&type=style&index=0&id=4c8b6824&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8b6824"],['__file',"src/components/ChatWidget/TvmFeedBack/TvmFeedBack.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c8b6824"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c8b6824', __exports__)) {
    api.reload('4c8b6824', __exports__)
  }
  
  module.hot.accept("./TvmFeedBack.vue?vue&type=template&id=4c8b6824&scoped=true", () => {
    api.rerender('4c8b6824', render)
  })

}


export default __exports__